<template>
  <v-btn dark
         large
         v-bind="$attrs"
         :color="color"
         v-on="$listeners"
         :loading="loading"
         :class="loading?'lock':''"
          @click="loader = 'loading'">
    <slot></slot>
  </v-btn>
</template>
<script>
import BaseBtn from './BaseBtn'
export default {
  name: 'btn-lg-primary',
  extends: BaseBtn,
  props: {
    color: {
      type: String,
      default: 'secondary'
    }
  }
}
</script>
<style lang="stylus" scoped></style>
